import { memo } from "react"
import { Image } from "@chakra-ui/image"

interface CollapsedLogoSidebarProps {
  src: string
}

function CollapsedLogoSidebar(props: CollapsedLogoSidebarProps) {
  const { src } = props

  return <Image objectFit="contain" w="35px" h="42px" mb="68px" mt="12px" ml="0px !important" src={src} />
}

export default memo(CollapsedLogoSidebar)
